module.exports = __webpack_public_path__ + "img/yrtpro_ios.9dd1bb72.png";